import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { GuideButton } from './shell/GuideButton';
import { NotificationBell } from './shell/NotificationBell';
import type { NotificationsControl, Role } from './shell/types';

interface TopBarProps {
  children: ReactNode;
  actions?: ReactNode;
  /** The provider's mark at the far right, after the bell. */
  brand?: ReactNode;
  notifications: NotificationsControl;
  role: Role;
  showNotifications: boolean;
  onOpenGuide?: () => void;
  onStartTour?: () => void;
}

export function TopBar({
  children,
  actions,
  brand,
  notifications,
  role,
  showNotifications,
  onOpenGuide,
  onStartTour,
}: TopBarProps): ReactNode {
  const showActions =
    Boolean(actions) || Boolean(brand) || showNotifications || onOpenGuide !== undefined;
  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        px: 6,
        py: 2,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      {showActions ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexShrink: 0,
          }}
        >
          {actions}
          {onOpenGuide ? (
            <GuideButton
              onOpenGuide={onOpenGuide}
              {...(onStartTour === undefined ? {} : { onStartTour })}
            />
          ) : null}
          {showNotifications ? (
            <NotificationBell
              notifications={notifications.items}
              role={role}
              onAct={notifications.onAct}
              onMarkAllRead={notifications.onMarkAllRead}
              onDismiss={notifications.onDismiss}
              {...(notifications.delivery === undefined
                ? {}
                : { delivery: notifications.delivery })}
            />
          ) : null}
          {brand}
        </Box>
      ) : null}
    </Box>
  );
}
